import React from "react";
import { Formik } from "formik";
import { Button } from "components/generic/kit";
import { Row, Label } from "components/generic/form/service";
import { BookWrap, InsiderCard, TimeSlots } from "components/common/candidate";

export default ({
  booking,
  date,
  initialValues,
  slots,
  loadMore,
  validationSchema,
  rescheduleApi,
  onSubmit,
  isLoading
}) => (
  <BookWrap
    isLoading={isLoading}
    bigTitle="Rescheduling"
    sidebar={<InsiderCard {...booking.insider} {...booking} />}
  >
    {() => (
      <div>
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          {props => (
            <form onSubmit={props.handleSubmit}>
              <Row>
                <Label title="Previous time start">
                  <div className="f6">{date}</div>
                </Label>
              </Row>
              <Row>
                <Label title="Schedule a new time for the call">
                  <TimeSlots insider={booking.time_slots} slots={slots} />
                </Label>
              </Row>
              <Row>
                <Button disabled={rescheduleApi.isFetching}>Reschedule</Button>
              </Row>
            </form>
          )}
        </Formik>
      </div>
    )}
  </BookWrap>
);



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/Reschedule/View.js